import { pathBuilder, peopleRoot } from 'config/paths/index';

export const basePath = (id) => {
  return `${peopleRoot}/${id}/badges`;
};

export const userPathsBuilder = (id) => {
  return pathBuilder(basePath(id));
};

const fullPathsConfig = userPathsBuilder(':id');
export default fullPathsConfig;
